<div mat-dialog-title class="ds">
  <span>{{ appStrings.invoice_trackingTitle }}</span>
  <button mat-icon-button class="close-dialog-button" mat-dialog-close>
    <mat-icon class="close-icon">close</mat-icon>
  </button>
</div>
<div mat-dialog-content class="content ds">

  <!-- desktop template -->
  <div *appIsDesktop>
    <typography class="orderNumber" variant="subtitle-1" weight="medium" id="orderNumber" >{{ appStrings.ln_orderNumber + ' - ' + orderNumber }}</typography>
    <ds-table class="trackingNumbers" mat-table [dataSource]="trackingNumberList" [displayedColumns]="displayedColumns">
      <ng-container matColumnDef="trackingNumber">
        <th mat-header-cell *matHeaderCellDef> {{ appStrings.quoteSearch_trackingNumber }} </th>
        <td mat-cell *matCellDef="let item;let i = dataIndex" [id]="'trackingNumber_'+i" > {{ item.trackingNumber }} </td>
      </ng-container>
      <ng-container matColumnDef="carrier">
        <th mat-header-cell *matHeaderCellDef> {{ appStrings.invoice_carrier }} </th>
        <td mat-cell *matCellDef="let item;let i = dataIndex" [id]="'carrier_'+i"> {{ item.carrier }} </td>
      </ng-container>
      <ng-container matColumnDef="goTo">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let item;let i = dataIndex" [id]="'goTo_'+i">
          <ds-button size="medium" type="tertiary" variant="label-icon" icon="keyboard_arrow_right" [label]="appStrings.tracking_goTo"
            (onClick)="openExternalTracking(item)" iconStyle="material-icons-outlined" iconPosition="right">
          </ds-button>
        </td>
      </ng-container>
    </ds-table>
  </div>

  <!-- mobile template -->
  <div *appIsMobile class="mobile container">
    <typography class="orderNumber" variant="subtitle-1" weight="medium" id="orderNumber" >{{ appStrings.ln_orderNumber + ' - ' + orderNumber }}</typography>
    <div class="mobile-card two-columns">
      @for (item of trackingNumberList; track item; let i = $index) {
        <div>
          <div class="row">
            <div class="column">
              <typography [id]="'trackingNumber_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.quoteSearch_trackingNumber }} </typography>
              <typography [id]="'trackingNumber_'+i" class="data" variant="body-2" weight="medium"> {{ item.trackingNumber }} </typography>
              <typography [id]="'carrier_label_'+i" class="label" variant="caption-2" weight="regular"> {{  appStrings.invoice_carrier }} </typography>
              <typography [id]="'carrier_'+i" class="data" variant="body-2" weight="medium"> {{ item.carrier }} </typography>
            </div>
            <div class="column align-end">
              <ds-button size="medium" type="secondary" variant="label-icon" icon="keyboard_arrow_right" [label]="appStrings.tracking_goTo"
                (onClick)="openExternalTracking(item)" iconStyle="material-icons-outlined" iconPosition="right">
              </ds-button>
            </div>
          </div>
          @if (i !== trackingNumberList.length) {
            <ds-divider></ds-divider>
          }
        </div>
      }
    </div>
  </div>
</div>
<div mat-dialog-actions align="end" class="ds">
  <div class="dialog-btn-wrapper">
    <ds-button id="dialogButton" variant="label-only" size="medium" type="primary" (onClick)="close()" [label]="appStrings.button_close"></ds-button>
  </div>
</div>
